import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'
import { SIDEBARFULLWIDTH, SIDEBARSMALLWIDTH } from '../customUtils/AppConstants'

const { height } = Dimensions.get('window')

const styles = StyleSheet.create({
    sidebarContainer: {
        position: 'fixed',
        left: 0,
        top: 0, // Ajustado a 0 según requerimiento (antes 60)
        bottom: 0,
        width: SIDEBARFULLWIDTH,
        zIndex: 999,
        backgroundColor: theme.colors.background,
        borderRightWidth: 0.5,
        borderRightColor: theme.colors.lightGray,
        boxShadow: `2px 0 3.84px ${theme.colors.shadow}`,
        elevation: 5,
    },
    sidebarContainerCollapsed: {
        width: SIDEBARSMALLWIDTH,
    },
    sidebar: {
        flex: 1,
        backgroundColor: theme.colors.background,
    },
    // Estilos de header removidos al eliminar el título
    sidebarContent: {
        flex: 1,
        paddingTop: 8,
    },
    sidebarItem: {
        marginHorizontal: 12,
        marginVertical: 4,
        borderRadius: 8,
        overflow: 'hidden',
        // backgroundColor debug removido
    },
    sidebarItemActive: {
        backgroundColor: theme.colors.colorPrimary + '15', // 15% opacity
        borderLeftWidth: 3,
        borderLeftColor: theme.colors.colorPrimary,
    },
    sidebarItemContent: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingVertical: 12,
        // backgroundColor debug removido
    },
    sidebarItemContentCollapsed: {
        justifyContent: 'center',
        paddingHorizontal: 0,
    },
    tabIcon: {
        marginRight: 12,
    },
    tabIconCollapsed: {
        marginRight: 0,
    },
    sidebarItemText: {
        fontSize: 14,
        fontWeight: '500',
    },
    sidebarItemTextActive: {
        color: theme.colors.colorPrimary,
        fontWeight: '600',
    },
    sidebarItemTextInactive: {
        color: theme.colors.textSecondary,
    },
    sidebarItemTextCollapsed: {
        display: 'none',
    },
    debugText: {
        padding: 16,
        color: theme.colors.textSecondary,
        fontSize: 12,
        fontStyle: 'italic',
        // backgroundColor debug removido
    },
    footerCollapsedHint: {
        paddingVertical: 8,
        fontSize: 10,
        textAlign: 'center',
        color: theme.colors.textSecondary,
    },
})

export default styles
